import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
import { Dashboard, Login, BankAccounts, PaymentRequestPage, Dealers, GatepassEntry, Indents } from './Pages';
import '../../node_modules/bootstrap/dist/css/bootstrap.css';
import '../../node_modules/bootstrap/dist/js/bootstrap.js';
import '../scss/style.scss'
import 'bootstrap'
import amruthLogo from "../assets/logo.png"
import varshiniLogo from "../assets/varshini_logo.png"
import { ActionCreators } from '../store/actionCreators';
import { RootState } from 'store/store';
import { BottomBar } from './Widgets';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { Indent } from './Pages/Indent';

function App() {
  const user = useSelector((state: RootState) => state.appdata);
  const dispatch = useDispatch();

  const checkLocalStorage = () => {
    let user_data = localStorage.getItem("user");
    if(user_data && user_data.length > 0) {
      let login_time = localStorage.getItem("login_time");
      if(login_time && login_time.length > 0) {
        let last_login_time = moment(login_time);
        if(moment().diff(last_login_time, 'days') <= 60) {
          let user_info = JSON.parse(user_data);
          dispatch(ActionCreators.login(user_info));
        }
      }
    }
  }

  const isAuthenticated = () => {
    if (!user.isUserLoggedIn) {
      checkLocalStorage();
      if (!user.isUserLoggedIn) {
        return false;
      }
    }
    return true;
  }

  const PrivateRoute = ({children}) => isAuthenticated() ? children : <Login />
  
  return (
    <div id="app">
      <Router>
        <nav className="navbar sticky-top navbar-dark bg-dark">
          <div className="container">
            <a className="navbar-brand" href="/">
              {process.env.REACT_APP_NAME && process.env.REACT_APP_NAME === "Varshini Fertilizers" ? (
                <img src={varshiniLogo} width="30" height="30" alt="" style={{ marginRight: 5 }} />
              ) : (
                <img src={amruthLogo} width="30" height="30" alt="" style={{ marginRight: 5 }} />
              )}
              {process.env.REACT_APP_NAME}
            </a>
              {!user.isUserLoggedIn &&
                <NavLink to="/login" className="btn btn-dark" style={{ marginLeft: 20, float: "right" }}>Login</NavLink>
              }
          </div>
        </nav>
        <div className="container">
          <div className="row" style={{ marginTop: 10, marginBottom: 60 }}>
              <Routes>
                <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute> } />
                <Route path="/bankAccounts" element={<PrivateRoute><BankAccounts /></PrivateRoute> } />
                <Route path="/paymentRequest" element={<PrivateRoute><PaymentRequestPage /></PrivateRoute> } />
                <Route path="/dealers" element={<PrivateRoute><Dealers /></PrivateRoute> } />
                <Route path="/gatepass" element={<PrivateRoute><GatepassEntry /></PrivateRoute> } />
                <Route path="/indents" element={<PrivateRoute><Indents /></PrivateRoute> } />
                <Route path="/indents/:id" element={<PrivateRoute><Indent /></PrivateRoute> } />
                <Route path="/login" element={ <Login /> } />
              </Routes>
          </div>
        </div>
        {user.isUserLoggedIn &&
          <BottomBar />
        }      
      </Router>
    </div>
  );
}

export default App;
